/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionLineItemFromJSON, SubscriptionLineItemToJSON, } from './SubscriptionLineItem.js';
/**
 * Check if a given object implements the SubscriptionGroupedLinesSpec interface.
 */
export function instanceOfSubscriptionGroupedLinesSpec(value) {
    if (!('lineItems' in value) || value['lineItems'] === undefined)
        return false;
    return true;
}
export function SubscriptionGroupedLinesSpecFromJSON(json) {
    return SubscriptionGroupedLinesSpecFromJSONTyped(json, false);
}
export function SubscriptionGroupedLinesSpecFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lineItems': (json['line_items'].map(SubscriptionLineItemFromJSON)),
    };
}
export function SubscriptionGroupedLinesSpecToJSON(json) {
    return SubscriptionGroupedLinesSpecToJSONTyped(json, false);
}
export function SubscriptionGroupedLinesSpecToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'line_items': (value['lineItems'].map(SubscriptionLineItemToJSON)),
    };
}
